import type * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Container for per-row action buttons. Visible at 60% opacity at rest,
 * full opacity on row hover OR keyboard focus-within — fixes the
 * "actions disappear for keyboard / touch users" pattern that was
 * everywhere (pages-list, campaigns-list, drafts-list, pixels-list,
 * file-tree). Wrap your buttons in this and ensure the parent row uses
 * `className="group"`.
 *
 *   <tr className="group">
 *     <td>...</td>
 *     <td className="text-right">
 *       <RowActions>
 *         <Button size="sm" variant="ghost" title="Rename">...</Button>
 *         ...
 *       </RowActions>
 *     </td>
 *   </tr>
 */
export function RowActions({ children, className }: {
    children: React.ReactNode;
    className?: string;
}): React.ReactNode {
    return (
        <div
            className={cn(
                "flex items-center justify-end gap-1",
                // 60% at rest, full on row hover / any child focus.
                "opacity-60 transition-opacity",
                "group-hover:opacity-100 focus-within:opacity-100",
                className,
            )}
        >
            {children}
        </div>
    );
}
